import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'

export const MERCHANT_USER_QUERY = gql`
	query GetMerchantUser {
		merchantMe {
			id
			firstName
			lastName
			email{
				email
				verified
			}
			phoneNumber
		}
	}
`

export const useCurrentMerchantUser = () => {
	return useQuery(MERCHANT_USER_QUERY)
}

export const useHasCompleteUserProfile = () => { 
	const { data, loading, error } = useQuery(MERCHANT_USER_QUERY);
	const user = data?.merchantMe;
  
	const hasFirstName = !!user?.firstName && user.firstName.trim() !== '';
	const hasLastName = !!user?.lastName && user.lastName.trim() !== '';
  
	const merchantUserProfileComplete = hasFirstName && hasLastName;
  
	return {
	  merchantUserProfileComplete,
	  loading,
	  error,
	};
  };